module.exports = __webpack_public_path__ + "static/media/edetailcard.7072dcdc.svg";